const MODULE_NAME = 'fulcrum/containers/Project/FileRenameDialog'

const SUBMIT = 'fulcrum/containers/Project/FileRenameDialog/SUBMIT'
const UPDATE_NAME = 'fulcrum/containers/Project/FileRenameDialog/UPDATE_NAME'
const UPDATE_ACTIVE = 'fulcrum/containers/Project/FileRenameDialog/UPDATE_ACTIVE'
const UPDATE_FILE_ID = 'fulcrum/containers/Project/FileRenameDialog/UPDATE_FILE_ID'
const MOUNT = 'fulcrum/containers/Project/FileRenameDialog/MOUNT'
const UNMOUNT = 'fulcrum/containers/Project/FileRenameDialog/UNMOUNT'

export {
  MODULE_NAME,
  SUBMIT,
  UPDATE_ACTIVE,
  UPDATE_FILE_ID,
  UPDATE_NAME,
  MOUNT,
  UNMOUNT,
}
